import * as Sentry from '@sentry/react';

export const SAVED_SESSION_STORAGE_KEY = 'savedSession';
const MAX_STORAGE_SIZE = 3 * 1024 * 1024; // limit is 5MB

export function restoreStoreState() {
    let storedData = sessionStorage.getItem(SAVED_SESSION_STORAGE_KEY) || null;
    if (storedData) {
        const savedState = JSON.parse(storedData);
        sessionStorage.removeItem(SAVED_SESSION_STORAGE_KEY);
        if (__VERSION__ === savedState?.version || isStoreCompatible(__VERSION__, savedState.version)) {
            try {
                app.store.dispatch(app.actions.restoreState(savedState.state));
            } catch (err) {
                console.error(err);
                location.reload(true);
            }
        }
    }
}

export function isStoreCompatible(versionA, versionB) {
    return versionA.length && versionA === versionB;
}

export function saveStoreState() {
    let sessionState = {
            version: __VERSION__,
            state: JSON.parse(JSON.stringify(app.store.getState())), // deep clone
        },
        serializedState;

    // delete entries that don't need to be saved
    delete sessionState.state.i18n;
    delete sessionState.state.notifications;
    delete sessionState.state.pushNotifications;
    delete sessionState.state.chat;
    delete sessionState.state.users;
    delete sessionState.state.connections;
    delete sessionState.state.onlineUsers;

    serializedState = JSON.stringify(sessionState);
    while (sessionState.state.events && serializedState.length > MAX_STORAGE_SIZE) {
        sessionState.state = trimState(sessionState.state);
        serializedState = JSON.stringify(sessionState);
    }
    console.log('Storing ', serializedState.length, 'characters');
    try {
        sessionStorage.setItem(SAVED_SESSION_STORAGE_KEY, serializedState);
    } catch (err) {
        // failed to store data
        sessionStorage.removeItem(SAVED_SESSION_STORAGE_KEY);
    }
}

/**
 * Nulifies part of the state to make it smaller
 * @param  {Object} state Store state
 * @return {Object}       Store state with less data
 */
function trimState(state) {
    if (state.events) {
        let trimmed = false;
        for (let eventId of state.events.loadedEvents) {
            for (let key of Object.keys(state.events[eventId]).filter(key => key != 'event')) {
                if (state.events[eventId][key]) {
                    // console.log(`Deleting state.events[${eventId}][${key}]`);
                    trimmed = true;
                    delete state.events[eventId][key];
                    break;
                }
            }
            if (trimmed) break;
        }
        if (trimmed) return state;
    }
    Sentry.addBreadcrumb(state.events.loadedEvents);
    Sentry.captureMessage('No more data to trim from events to fit storage');
    return {...state, events: null};
}
